import { useOptionalAuth } from '@/features/auth/authContext';

/**
 * Whether the Listen control should be RENDERED for a given vehicle (slice 86).
 *
 * 🔴 TWO GATES, AND NOTE WHICH ONE IS ABSENT.
 *   1. `micFitted` — the hardware fact. No mic ⇒ no control anywhere (absence
 *      over disabled, CLAUDE.md). The server returns `micFitted: false` and
 *      refuses a direct POST with 409 `mic_not_fitted`.
 *   2. ROLE — `owner` or `manager`. A `viewer` never sees it; the server refuses
 *      a viewer with 403 `rejected_role`.
 *
 * 🔴 THERE IS DELIBERATELY NO `useTenantWritable` GATE HERE. Listen is a safety
 * call-back to the owner's own phone on the owner's own hardware and is ALLOWED
 * while the tenant is suspended (PLAN E1 — it matches SOS acknowledge, not an
 * ordinary write). Gating it on writability would HIDE the capability from a
 * suspended tenant that the server would in fact honour. Call-back NUMBER
 * management is the ordinary write and gates on writability in its own panel.
 *
 * 🔴 USES `useOptionalAuth`, NOT `useAuth` — the discipline every gate here
 * follows. The control is unit-tested without an `<AuthProvider>`; `useAuth`
 * throws there. No provider ⇒ no authenticated person ⇒ no control, the safe
 * default and the real signed-out state.
 */
export function useCanListen(micFitted: boolean): boolean {
  const ctx = useOptionalAuth();
  if (!micFitted) return false;
  if (!ctx || ctx.state.status !== 'authenticated') return false;
  const role = ctx.state.user.role;
  return role === 'owner' || role === 'manager';
}
